import React from "react"
import { node } from "prop-types"

const Base = ({ children }) => (
  <div >
    <section>{children}</section>
  </div>
)
Base.propTypes = {
  children: node,
}
export default Base



// WEBPACK FOOTER //
// ./src/components/layout/Base.js